import { Box } from "@mui/material";
import { type ButtonProps as MUIButtonProps } from "@mui/material/Button";
import { useLocation } from "@reach/router";
import { Icons } from "@repo/ui";
import { type GatsbyLinkProps } from "gatsby";
import { Button } from "gatsby-theme-material-ui";
import { type FC, type PropsWithChildren } from "react";

type GatsbyThemeMUIButtonProps = GatsbyLinkProps<unknown> & MUIButtonProps

export type InternalButtonLinkProps = PropsWithChildren<GatsbyThemeMUIButtonProps & {
	variant?:
	| "contained"
	| "outlined"
	| "text"
	| "appBarLink"
	| "contactLink"
	| "clear";
}>

const InternalButtonLink: FC<InternalButtonLinkProps> = ({
	children,
	href,
	variant = "contained",
	...rest
}) => {
	return (
		<Button
			to={href}
			variant={variant}
			underline="none"
			disableElevation={true}
			{...rest}
		>
			{children}
		</Button>
	);
};
export default InternalButtonLink;

export const InternalAttentionLink: FC<InternalButtonLinkProps> = ({
	children,
	startIcon,
	sx,
	to,
	...rest
}) => {
	const { pathname } = useLocation();

	return (
		<InternalButtonLink
			variant={pathname === to ? "text" : "clear"}
			size="small"
			{...rest}
			to={to}
			sx={{
				...sx,
				p: 3,
				textAlign: "left",
				".MuiButton-startIcon": {
					width: 40,
					minWidth: 40,
					m: 0,
				},
			}}
			startIcon={startIcon}
			endIcon={<Icons.CaretRight sx={{ width: 7 }} />}
		>
			<Box component="span" sx={{ flexGrow: 1 }}>
				{children}
			</Box>
		</InternalButtonLink>
	);
};
